import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListSDM } from "@/services/getData"

export default function MasterSdmPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listSDM"],
    queryFn: () => getListSDM(),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
